var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramCards128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/xLarge./Cards128",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(7.000000, 27.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "card",
    fill: "#FFFFFF",
    x: 1.5,
    y: 1.5,
    width: 111,
    height: 71,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6280356,1.5 L55.05216,37 L90.6280356,72.5 L106,72.5 C109.589851,72.5 112.5,69.5898509 112.5,66 L112.5,8 C112.5,4.41014913 109.589851,1.5 106,1.5 L90.6280356,1.5 Z",
    id: "focus",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0047186,17.126039 L16.1213414,24.0707981 L22.9952603,30.8834194 L29.8786797,24 L23.0047186,17.126039 Z",
    id: "brand",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramCards128);
export default __webpack_public_path__ + "static/media/pictogramCards128.33daa0c60586b4aee26cb2a21a4323a0.svg";
export { ForwardRef as ReactComponent };